import React from 'react';
import * as PropTypes from 'prop-types';
import helpers from "../../helpers/helpers";

const {getTranslationText} = helpers;

const Textarea = (props) => {
    const {
        name,
        high,
        value,
        label,
        onChange,
        placeholder,
        labelAdditional,
        symbolCount
    } = props;
    const markdown_desc = getTranslationText(labelAdditional).replace('{count}', symbolCount);
    return (
        <div className="form-field">
            <label htmlFor={name}>{getTranslationText(label)}</label>
            {labelAdditional && (
                <div dangerouslySetInnerHTML={{__html: markdown_desc}}/>
            )}
            <textarea
                id={name}
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                className={`${high ? 'high' : ''}`}
                value={value}
            />
        </div>
    )
};

Textarea.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
};

Textarea.defaultProps = {
    label: 'Textarea label',
    name: '',
    placeholder: '',
};

export default Textarea;
